import(/* webpackMode: "eager" */ "/home/ec2-user/ennix-electronics/src/app/contactus/loading.js");
